import React from 'react';
import { Select as HeroSelect, SelectItem } from '@heroui/react';
import Typography from '../typography/Typography';

interface SelectOption {
  key: string;
  label: string;
  value: string;
}

interface SelectProps {
  label?: string;
  placeholder?: string;
  selectedKeys?: string[];
  onSelectionChange?: (keys: string[]) => void;
  options: SelectOption[];
  isRequired?: boolean;
  isDisabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  variant?: 'bordered' | 'underlined' | 'filled' | 'flat';
  className?: string;
  description?: string;
  errorMessage?: string;
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  fullWidth?: boolean;
}

export const Select: React.FC<SelectProps> = ({
  label,
  placeholder,
  selectedKeys = [],
  onSelectionChange,
  options,
  isRequired = false,
  isDisabled = false,
  size = 'sm',
  color = 'default',
  variant = 'bordered',
  className = '',
  description,
  errorMessage,
  startContent,
  endContent,
  fullWidth = false,
}) => {
  return (
    <div className={`flex flex-col gap-2 ${fullWidth ? 'w-full' : ''} ${className}`}>
      <Typography variant="body2">
        {label}
        {isRequired && <span className="text-partner">&nbsp;*</span>}
      </Typography>
      <HeroSelect
        // label={label}
        labelPlacement="outside"
        placeholder={placeholder}
        selectedKeys={selectedKeys}
        //@ts-ignore
        onSelectionChange={onSelectionChange}
        isRequired={isRequired}
        isDisabled={isDisabled}
        size={size}
        color={color}
        //@ts-ignore
        variant="bordered"
        description={description}
        errorMessage={errorMessage}
        startContent={startContent}
        endContent={endContent}
        className="w-full"
        classNames={{
          base: 'min-h-10 max-h-[12.5rem]',
          label: 'mb-2 text-sm font-medium text-auth-ink',
          trigger: ' rounded-2 !min-h-[2.375rem] !h-[2.375rem]',
          value: 'text-sm text-auth-muted',
        }}
        // classNames={{
        //   base: "min-h-10 max-h-[6.25rem]",
        //   trigger: "h-10",
        //   value: "text-sm text-auth-ink",
        //   label: "text-sm font-medium text-auth-ink",
        //   description: "text-xs text-auth-muted",
        //   errorMessage: "text-xs text-auth-strength-weak"
        // }}
      >
        {options.map((option) => (
          //@ts-ignore
          <SelectItem key={option.key} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </HeroSelect>
    </div>
  );
};
